import { Button, Modal, Space, Typography } from "antd";
import { times } from "lodash";
import React, { useState } from "react";
import { Document  as PDFDocument, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack5";
import { Icon } from "@iconify/react";

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

interface Props {
  title?: string;
  subTitle?: string;
  show: boolean;
  setShow: (value: boolean) => void;
  url: string;
}

export const PDFViewer = ({ title, show, setShow, url, subTitle }: Props) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [scale, setScale] = useState<number>(1);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  const zoomIn = () => {
    setScale(scale + 0.1);
  };

  const zoomOut = () => {
    if (scale > 0.1) {
      setScale(scale - 0.1);
    }
  };

  return (
    <Modal
      title={
        <Space size={0} direction="vertical">
          <Typography.Title level={4} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
          {subTitle && (
            <Typography.Text type="secondary">{subTitle}</Typography.Text>
          )}
        </Space>
      }
      open={show}
      maskClosable={false}
      cancelText={"Close"}
      onCancel={() => setShow(false)}
      okButtonProps={{
        hidden: true,
      }}
      width={
        window.innerWidth <= 1000
          ? window.innerWidth
          : window.innerWidth - window.innerWidth * 0.1
      }
      bodyStyle={{ height: window.innerHeight - 200, overflowY: "scroll" }}
      footer={[
        <Button key="zoomOut" onClick={zoomOut}>
          <Icon
            icon="akar-icons:minus"
            inline
          />
        </Button>,
        <Button key="zoomIn" onClick={zoomIn} >
          <Icon
            icon="akar-icons:plus"
            inline
          />
        </Button>,
      ]}
      centered
    >
      <PDFDocument
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={console.error}
        renderMode="canvas"
        externalLinkTarget="_blank"
      >
        <Space
          size="small"
          align="center"
          style={{
            width: "100%",
            justifyContent: "center",
          }}
          direction="vertical"
        >
          {times(numPages, (page) => (
            <div
              key={page}
              style={{
                border: "1px solid rgba(0,0,0,.2)",
                padding: 10,
              }}
            >
              <Page
                pageNumber={page + 1}
                width={window.innerWidth - window.innerWidth * 0.3}
                scale={scale}
                renderAnnotationLayer={true}
                renderTextLayer={false}
              />
            </div>
          ))}
        </Space>
      </PDFDocument>
    </Modal>
  );
};
